import { render } from "./settingheadertab.vue?vue&type=template&id=060ce17e&scoped=true"
import script from "./settingheadertab.vue?vue&type=script&lang=js"
export * from "./settingheadertab.vue?vue&type=script&lang=js"

import "./settingheadertab.vue?vue&type=style&index=0&id=060ce17e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060ce17e"]])

export default __exports__